export const DEFAULT_THEME = 'hg-theme-default';

export enum SPECIAL_KEYS {
  TAB = '{tab}',
  SHIFT = '{shift}',
  SPACE = '{space}',
  BACKSPACE = '{bksp}',
  ENTER = '{enter}',
  NEXT_KEYBOARD = '{nextKeyboard}',
  CONFIRM = '{confirm}',
  SPECIAL = '{special}',
  DEFAULT = '{default}',
  AT = '{@}',

  // Japanese Kana keyboard keys
  NUMBERS = '{numbers}',
  ABC = '{abc}',
  KANA = '{kana}',
  SMALL = '{small}',
  ZENKAKU = '{zenkaku}',
  DIVIDER = '{divider}',
  BRACKETS = '{brackets}',

  NEXT_CANDIDATE = '{nextCandidate}',
  KAOMOJI = '{kaomoji}',

  PREV_SEGMENT = '{prevSegment}',
  NEXT_SEGMENT = '{nextSegment}',

  // Previous version
  CONVERT = '{convert}',
  HIRAGANA = '{hiragana}',
  KATAKANA = '{katakana}',
  CONVERT_HIRAGANA = '{convertHiragana}',
}
